import React, { Component } from "react";
import { connect } from "react-redux";
import "./presentaionView.scss";
import { LoadingMask, Button } from "../../../../../common";
import { notificationAction } from "./../../../../../actions";
import ImgSrc from "../../../../../assets/images/company.svg";

import {
  getAllPresenationApi,
  acceptOpportunityApi,
} from "./../opportunityApi";
import { Col, Row, Select } from "antd";

class PresentationDetailsNew extends Component {
  state = {
    selectedOption: null,
    allpresentation: [],
    selectedPresentation: {},
    selectedUserDetail: null,
    isLoading: false,
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    this.getAllPresentation();
  }

  getAllPresentation = () => {
    getAllPresenationApi().then((data) => {
      if (data.success) {
        const allpresentation = data.items.map((item) => ({
          ...item,
          Logo: item.Logo,
          value: item.UserDetailId,
          label: item.Title,
        }));

        this.setState({
          allpresentation,
          selectedPresentation: allpresentation[0],
        });
        this.setState({ isLoading: false });
      }
    });
  };
  renderSocialMedia = (links) => {
    var slinks = this?.state?.selectedPresentation?.SocialLinks;
    var list = [];
    for (var i = 0; i < slinks?.length; i++) {
      var name = this.props.socialMedia.find(
        (e) => e.Id === slinks[i].SocialMediaId
      );
      list.push(
        <label
          className={`social-links ${name.Name.toLowerCase()}`}
          key={slinks[i].SocialMediaId}
        >
          <a href={slinks.URL} target="_blank" key={slinks[i].SocialMediaId}>
            {name.Name}
          </a>
          <br />
        </label>
      );
    }
    return list;
  };

  handPresentSelectChange = (selectedOption) => {
    this.setState({ selectedOption, selectedPresentation: selectedOption });
  };

  handleSubmitPresentDetail = (data) => {
    this.setState({ userDetail: data });
    const { selectedOpportunityNew, userDetail } = this.state;
    const obj = new Object();
    obj.RequestId = this.props.selectedOpportunityNew.RequestId;
    obj.UserDetailId = this.state.selectedPresentation.UserDetailId;
    //obj.CoverLetter = this.state.selectedPresentation.Detail;
    obj.ResumeId = 0;
    //obj.RequestName = this.props.selectedOpportunityNew.RequestName;

    this.acceptOpportunity(obj);
  };

  acceptOpportunity = (info) => {
    acceptOpportunityApi(info).then((data) => {
      if (data.success) {
        const info = {
          message: this.props.labels.iproOppNewAcceptMessage,
          status: "success",
        };
        this.props.notificationAction(info);
        this.props.getAllOpportunity();
        this.props.handleOk();
      }
    });
  };

  render() {
    const {
      labels,
      selectedOpportunityNew,
      showCompanyDetails,
      showPresentationDetail,
      loading,
      socialMedia,
      getAllOpportunity,
    } = this.props;
    const {
      selectedOption,
      allpresentation,
      selectedPresentation,
    } = this.state;
    return (
      <div className="new-presentation-detail-component">
        {loading && <LoadingMask />}
        <div className="inner-company">
          <Select
            size="large"
            showArrow
            className="bg-color-for-opportunity"
            bordered={false}
            style={{ width: "100%" }}
            value={selectedPresentation && selectedPresentation}
            placeholder={labels.presentPrimaryRolePlaceholder}
            onChange={(e, selectedOption) =>
              this.handPresentSelectChange(selectedOption)
            }
            options={allpresentation}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.props?.label
                ?.toLowerCase()
                ?.indexOf(input?.toLowerCase()) >= 0
            }
          ></Select>

          <div className="MsgWrapper">
            <div className="image-user">
              {selectedPresentation && selectedPresentation.Logo && (
                <img
                  src={selectedPresentation.Logo || ImgSrc}
                  className={
                    selectedPresentation.Logo ? "roundImg" : "emptyRoundImag"
                  }
                />
              )}
            </div>
            <p className="user-title">{selectedPresentation.Title}</p>

            <Row
              gutter={[16, 20]}
              className="pt-2"
            >
              <Col xs={24} md={12}>
                <p className="fnt-s-14 mb-1 clr-gray"> {this.props.labels.IproOpportunityNewUserNameLabel}</p>
                <p className="fnt-s-16 m-0 clr-black">{selectedPresentation?.UserName || "N/A"}</p>
              </Col>
              <Col xs={24} md={12}>
                <p className="fnt-s-14 mb-1 clr-gray"> {this.props.labels.IproOpportunityNewUserPositionLabel}</p>
                <p className="fnt-s-16 m-0 clr-black">{selectedPresentation?.Profiles?.ProfileValue || "N/A"}</p>
              </Col>
              <Col xs={24} md={12}>
                <p className="fnt-s-14 mb-1 clr-gray"> {this?.props?.labels?.IproOpportunityNewUserEmailLabel}</p>
                <p className="fnt-s-16 m-0 clr-black">{selectedPresentation?.UserEmails?.UserEmailValue || "N/A"}
                </p>
              </Col>


              <Col xs={24} md={12}>
                <p className="fnt-s-14 mb-1 clr-gray"> {this?.props?.labels?.IproOpportunityNewUserPhoneLabel}</p>
                <p className="fnt-s-16 m-0 clr-black">{selectedPresentation?.UserPhonenumbers?.UserPhonenumberValue || "N/A"}
                </p>
              </Col>
              <Col xs={24} md={12}>
                <p className="fnt-s-14 mb-1 clr-gray"> {this?.props?.labels?.IproOpportunityNewUserWebURL}</p>
                <p className="fnt-s-16 m-0 clr-black">
                  <a target="_blank" href={selectedPresentation.WebUrl}>
                    {selectedPresentation.WebUrl || "N/A"}
                  </a>
                </p>
              </Col>
              <Col xs={24} md={12}>
                <p className="fnt-s-14 mb-1 clr-gray">Social Links</p>
                <p className="fnt-s-16 m-0 clr-black">
                  {selectedPresentation?.SocialLinks?.length > 0 ? this.renderSocialMedia(
                    selectedPresentation?.SocialLinks || []
                  ) : "N/A"}{" "}
                </p>
              </Col>

              <Col xs={24} md={24}>
                <p className="fnt-s-14 mb-1 clr-gray"> Details</p>
                <p className="fnt-s-16 m-0 clr-black">
                  {selectedPresentation.Detail || "N/A"}
                </p>
              </Col>
            </Row>
            <div className="btn-footer">
              <button
                className="btn-delete clr-purple "
                onClick={this.handleSubmitPresentDetail}
              >
                {"Send"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ systemLabel }) => {
  const { labels } = systemLabel;
  return { labels };
};
export default connect(mapStateToProps, { notificationAction })(
  PresentationDetailsNew
);
